import {observer} from 'mobx-react'
import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import PageSubHeader from '../../components/common/page_sub_header'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import {formatNumber, string} from '../../helper/common'
import ConfirmButton from '../../components/control/button/confirm_button'
import ItemBuyModal from '../../components/control/modal/modal_item_buy'
import {rootStore} from '../../mobx/store'

const Item = observer((props) => {
  const context = useContext(Page_settings)
  let [itemList, setItemList] = useState([])
  let [couponList, setCouponList] = useState([])
  let [selectedItem, setSelectedItem] = useState(Object)
  let [showBuyModal, setShowBuyModal] = useState(false)

  const tbHeaders = [
    {
      name: strings.item_name,
      class: 'td-item-name pl-40',
      center: false
    },
    {
      name: strings.price_won,
      class: 'td-item-price',
      divider: false
    },
    {
      name: '',
      class: 'td-item-button',
    },
  ]

  useEffect(() => {
    getItemList()
  }, [])

  const getItemList = () => {
    context.post('pay/item_list', {},
      response => {
        setItemList(response.list)
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const getCouponList = (item) => {
    context.post('pay/coupon_list', {min_price: item.it_price},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setCouponList(response.list)
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const onClickBuy = (index) => {
    if (!rootStore.isSignedIn) {
      props.history.push('/login')
      return
    }

    const mb_lv = rootStore.getMe.mb_lv
    const item = itemList[index]
    if (mb_lv != 2 && mb_lv != 3) {
      context.showAlert(strings.analyst_only)
      return
    }
    getCouponList(item)
    setSelectedItem(item)
    setShowBuyModal(true)
  }

  const onItemBuy = (point, coupon) => {
    setShowBuyModal(false)
    const mb_point = rootStore.getMe.mb_point
    if (Number(mb_point) < Number(point)) {
      context.showPointLack(2, point, () => {
        context.showPointPay()
      })
      return
    }
    context.post('pay/item_buy', {it_id: selectedItem.it_id, point: point, cp_price: coupon?.cp_price ?? 0, cp_id: coupon?.cp_id ?? 0},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        context.showAlert(strings.item_buy_success)
      },
      true,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft history={props.history} />
        <div className='im-container'>
          <PageSubHeader pageName={strings.item_purchase} pageMenu1={strings.main} pageMenu={strings.item_purchase}/>
          <TableHeader className={'mt-30'} headers={tbHeaders}/>
          {
            itemList.map((info, index) => {
              return (
                <div key={index} className='tb-row cursor-point'>
                  <TableCell
                    value={info.it_name}
                    className={tbHeaders[0].class}
                    center={tbHeaders[0].center}
                    child={
                      <div className='w-100 pl-30'>{info.it_name}</div>
                    }
                  />
                  <TableCell
                    value={string.Format(strings.format_won, formatNumber(info.it_price))}
                    className={tbHeaders[1].class}
                    center={tbHeaders[1].center}
                    child={null}
                  />
                  <TableCell
                    value={''}
                    className={tbHeaders[2].class}
                    center={tbHeaders[2].center}
                    child={
                      <ConfirmButton enabled={true} className={'bd-0 item-buy-button fs-15 sm-fs-14 f-m'} onClick={() => {onClickBuy(index)}} text={strings.buying} />
                    }
                  />
                </div>
              )
            })
          }
          <ItemBuyModal item={selectedItem} couponList={couponList} show={showBuyModal} toggle={() => {setShowBuyModal(!showBuyModal)}} onConfirm={(point, coupon)=> {onItemBuy(point, coupon)}}/>
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(Item)
